const backgroundClip = {
  name: "background-clip",
  path: "/background-clip",
  title: "Background Clip",
  description: "Utilities for controlling the clipping behavior of the background area.",
  value: {
    "background-clip": {
      "bg-clip-border": "border-box",
      "bg-clip-padding": "padding-box",
      "bg-clip-content": "content-box",
      "bg-clip-text": "text"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<div class="border-3 bg-indigo-500 bg-clip-border p-3"></div>
<div class="border-3 bg-indigo-500 bg-clip-padding p-3"></div>
<div class="border-3 bg-indigo-500 bg-clip-content p-3"></div>
<span class="bg-clip-text text-color-transparent bg-gradient-[linear-gradient(45deg,color-pink-500,color-purple-500)]">Unicss</span>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-clip-border</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-clip-padding</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-clip-content</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-clip-text</code> to control background clipping.
      </p>
      <div class="flex gap-10 justify-between">
        <div class="flex flex-col items-center">
          <small class="mb-2 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-clip-border</small>
          <div class="border-3 border-color-white/50 border-style-dashed size-28 bg-color-indigo-500 bg-clip-border p-3 rounded-lg"></div>
        </div>
        <div class="flex flex-col items-center">
          <small class="mb-2 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-clip-padding</small>
          <div class="border-3 border-color-indigo-500/50 border-style-dashed size-28 bg-color-indigo-500 bg-clip-padding p-3 rounded-lg"></div>
        </div>
        <div class="flex flex-col items-center">
          <small class="mb-2 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-clip-content</small>
          <div class="border-3 border-color-indigo-500/50 border-style-dashed size-28 bg-color-indigo-500 bg-clip-padding p-3 rounded-lg bg-clip-content"></div>
        </div>
        <div class="flex flex-col items-center">
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">bg-clip-text</small>
          <span class="bg-clip-text text-color-transparent bg-gradient-[linear-gradient(45deg,color-pink-500,color-purple-500)] text-5xl font-bold uppercase">Unicss</span>
        </div>
      </div>
      `
    }
  ]
};

export default backgroundClip;
<div className="border-3 text-color-transparent bg-clip-text bg-gradient-[linear-gradient(45deg,color-pink-500,color-purple-500)] border-style-dashed border-color-white/50 border-color-indigo-500/50 bg-color-indigo-500 bg-clip-border p-3 rounded-lg size-28 bg-clip-padding bg-clip-content"></div>